// ------------------------------------------------------------
// AI Attribution — per Loren Data AI Use Policy §8.2
// Tool:        Claude Code (Anthropic)
// 2026-07-15: Added FE command for admin convert-to-contract action (WI9896 Phase 4) - SangPham
// ------------------------------------------------------------
/**
 * ConvertToContractCommand - Convert a developer network to a long-term contract
 * Follows MediatR pattern (Command + Handler in same file)
 */

import type { ICommand, ICommandHandler, IHttpClient, BaseApiResponse } from '@/application/core';
import type { ConvertToContractResult } from '@/application/queries/developerPlan/developer-plan.types';
import { toCamelCase } from '@/utils/caseTransform';

// ============================================================================
// Command (Request)
// ============================================================================

export class ConvertToContractFECommand implements ICommand<ConvertToContractResult> {
  readonly type = 'ConvertToContractFECommand' as const;

  constructor(public readonly networkId: number) {}
}

// ============================================================================
// Handler
// ============================================================================

export class ConvertToContractFECommandHandler
  implements ICommandHandler<ConvertToContractFECommand, ConvertToContractResult>
{
  constructor(private readonly httpClient: IHttpClient) {}

  async handle(command: ConvertToContractFECommand): Promise<ConvertToContractResult> {
    try {
      const response = await this.httpClient.post<BaseApiResponse<any>>(
        `/api/v1/developer-plan/${command.networkId}/convert-to-contract`
      );

      if (!response.succeeded) {
        throw new Error(response.message || 'Failed to convert network to contract');
      }

      return toCamelCase(response.data) as ConvertToContractResult;
    } catch (error: any) {
      if (error.response?.status === 403 || error.status === 403) {
        throw new Error('Forbidden - insufficient permissions');
      }
      throw error;
    }
  }
}
